import script from "./ForgotPassword.vue?vue&type=script&setup=true&lang=ts"
export * from "./ForgotPassword.vue?vue&type=script&setup=true&lang=ts"

import "./ForgotPassword.vue?vue&type=style&index=0&id=a8bfea18&lang=css"

const __exports__ = script;

export default __exports__